import { Modal, Button } from "react-bootstrap";
import SharedForm from "../../../components/ui/Form";
import {
    AG_RECRUITMENT_APPLICATION_STATUS_VALUE,
    ALERT_TYPE,
    ALIGN, APPLICATION_SUBMISSION_TYPE,
    EAC_PHONE_TYPE,
    FORM_ACTION_TYPE,
    LANGUAGE_TYPE,
    POSITIONS,
    VALIDATIONS,
    YES_NO_INVERSE
} from '../../../constants';
import { useContext, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { AlertContext } from "../../../context/AlertContext";
import messages from "../../../utils/helper/messages";
import {
    addAdvisoryGroupRecruitmentApplicationData,
    updateAdvisoryGroupRecruitmentApplicationData,
} from '../../../ducks/advisoryGroup';
import api from '../../../services/api/cohortService';
import {
    isObjectEmpty,
    optionValues,
    pickProps,
    removeHyphens,
    toDate,
    todayEndofDay,
    radioOptionValues,
    checkObjectsEqual,
    checkAllowedSpecialExists,
    formatAddress,
    toFormDateTime,
    isSameOrBeforeToday
} from '../../../utils/utils';
import DataGrid from "../../../components/DataGrid";
import LoadingButton from "../../../components/ui/LoadingButton";
import styles from './MemberApplicationModal.module.scss';


const MemberApplicationModal = ({ show, action, onCancel, languageOptions, stateOptions, cohortId = null, data = null, }) => {
    const dispatch = useDispatch();
    const { showAlert } = useContext(AlertContext);

    const currentUser = useSelector((state) => state.user.currentUser);
    const pickList = useSelector((state) => state.company?.pickList);

    const [initialNormalizedData, setInitialNormalizedData] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [applicationDetails, setApplicationDetails] = useState(null);
    const [startTime, setStartTime] = useState(new Date());
    const [cloneFlag, setCloneFlag] = useState(false);
    const [noPhoneChecked, setNoPhoneChecked] = useState(false);
    const [search, setSearch] = useState(false);
    const [searchData, setSearchData] = useState(null);
    const [isSearchLoading, setIsSearchLoading] = useState(false);
    const [showApplicationForm, setShowApplicationForm] = useState(false);
    const [searchType, setSearchType] = useState(null);
    const [autoFillMessage, setAutoFillMessage] = useState('');

    const hideOtherLang = applicationDetails?.primaryLanguage !== LANGUAGE_TYPE.Other;
    const showNeedTranslator = applicationDetails?.primaryLanguage && applicationDetails.primaryLanguage !== LANGUAGE_TYPE.English;
    const showInternetAccessComment = applicationDetails?.deviceWithInternetAccess === YES_NO_INVERSE.No;

    const arr = [
        {
            key: 'participateReason',
            labelName: 'Why are you interested in joining our Advisory Committee?',
            placeholderName: 'Please enter any comments you would like to share.',
            type: 'textarea',
            required: false,
            valid: VALIDATIONS.String.noSpecialChars,
            maxLength: 255,
            charCounter: true
        },
        {
            key: 'applicationHealthPlanId',
            labelName: 'Health Plan ID',
            placeholderName: 'Health Plan ID',
            type: 'text',
            required: false,
        },
        {
            key: 'birthday',
            labelName: 'Birthdate',
            placeholderName: '',
            type: 'date',
            maxValue: todayEndofDay(),
        },
        {
            key: 'firstName',
            labelName: 'First Name',
            placeholderName: 'First Name',
            type: 'text',
            maxLength: 35,
            valid: VALIDATIONS.String.isName,
        },
        {
            key: 'lastName',
            labelName: 'Last Name',
            placeholderName: 'Last Name',
            type: 'text',
            maxLength: 35,
            valid: VALIDATIONS.String.isName,
        },
        {
            key: 'address',
            labelName: 'Address Line 1',
            placeholderName: 'Address Line 1',
            type: 'text',
            maxLength: 35,
            copyGroup: ['address', 'address2', 'city', 'state', 'postalCode'],
            copyAction: formatAddress,
        },
        {
            key: 'address2',
            labelName: 'Address Line 2',
            placeholderName: 'Address Line 2',
            type: 'text',
            maxLength: 35,
            required: false
        },
        {
            key: 'city',
            labelName: 'City',
            placeholderName: 'City',
            type: 'text',
            maxLength: 50,
        },
        {
            key: 'state',
            labelName: 'State',
            placeholderName: 'State',
            type: 'options',
            optionValues: optionValues(stateOptions, true),
            maxLength: 2
        },
        {
            key: 'postalCode',
            labelName: 'Zip',
            placeholderName: 'Zip',
            type: 'text',
            minLength: 5,
            maxLength: 9,
            valid: VALIDATIONS.Number.isZipCode
        },
        {
            key: 'phone',
            labelName: 'Phone',
            placeholderName: 'Phone',
            type: 'tel',
            maxLength: 12,
            valid: VALIDATIONS.Number.isPhone,
            cols: 6,
            disabled: noPhoneChecked,
            required: !noPhoneChecked,
            customError: 'Phone is required or else check the box below.',
            removeSpacing: true
        },
        {
            key: 'phoneType',
            labelName: 'Phone Type',
            placeholderName: 'Phone Type',
            type: 'radio',
            optionValues: radioOptionValues(EAC_PHONE_TYPE, true),
            cols: 6,
            disabled: noPhoneChecked,
            required: false,
            removeSpacing: true
        },
        {
            key: 'noPhone',
            labelName: '',
            type: 'checkbox',
            optionValues: [
                { id: 'noPhoneCheck', label: 'I do not have a phone number', value: "noPhone" },
            ],
            required: false,
            disabled: !!applicationDetails?.phone,
        },
        {
            key: 'email',
            labelName: 'Email',
            placeholderName: 'Email',
            type: 'email',
            required: false,
            maxLength: 255
        },
        {
            key: 'primaryLanguage',
            labelName: 'Primary Language',
            placeholderName: 'Primary Language',
            type: 'options',
            optionValues: optionValues(languageOptions, true),
            maxLength: 50,
        },
        {
            key: "primaryLanguageOther",
            labelName: "Specify Language",
            placeholderName: "Specify Language",
            type: "text",
            maxLength: 50,
            hidden: hideOtherLang,
            required: !hideOtherLang,
        },
        {
            key: 'needTranslator',
            labelName: 'Need Translator?',
            placeholderName: 'Need Translator?',
            type: 'radio',
            hidden: !showNeedTranslator,
            required: showNeedTranslator,
            optionValues: radioOptionValues(YES_NO_INVERSE, true)
        },
        {
            key: 'deviceWithInternetAccess',
            labelName: 'Device with Internet Access',
            type: 'radio',
            required: false,
            optionValues: radioOptionValues(YES_NO_INVERSE, true)
        },
        {
            key: "deviceWithInternetAccessComment",
            labelName: "",
            placeholderName: "Provide any additional information.",
            type: "text",
            required: false,
            maxLength: 50,
            hidden: !showInternetAccessComment,
            valid: VALIDATIONS.String.noSpecialChars,
            charCounter: true
        },
    ];

    const searchFormArr = [
        {
            key: 'searchByApplicationHealthPlanId',
            labelName: 'Health Plan ID',
            placeholderName: 'Health Plan ID',
            type: 'text',
            required: false,
            resetFields: ['searchByName'],
        },
        {
            key: 'searchByName',
            labelName: 'Name',
            placeholderName: 'Enter first and last name',
            type: 'text',
            maxLength: 70,
            valid: VALIDATIONS.String.isName,
            required: false,
            resetFields: ['searchByApplicationHealthPlanId'],
        },
    ]

    const columns = [
        {
            id: 'healthPlanMemberId',
            header: 'Health Plan ID',
            accessorKey: 'healthPlanMemberId',
        },
        {
            id: 'birthday',
            header: 'Birthdate',
            accessorKey: 'birthday',
            cell: info => info.getValue() ? toFormDateTime(info.getValue()) : '',
        },
        {
            id: 'firstName',
            header: 'First Name',
            accessorKey: 'firstName',
            sortingFn: 'text',
        },
        {
            id: 'lastName',
            header: 'Last Name',
            accessorKey: 'lastName',
            sortingFn: 'text',
        },
        {
            id: 'city',
            header: 'City',
            accessorKey: 'city',
            sortingFn: 'text',
        },
        {
            id: 'phone',
            header: 'Phone',
            accessorKey: 'phone',
        },
        {
            id: 'actions',
            header: '',
            cell: ({ row }) => (
                <Button
                    size="sm"
                    onClick={() => {
                        setApplicationDetails(row.original);
                        setShowApplicationForm(true);
                        setSearchData(null);
                        setAutoFillMessage(messages.info.autoFillSelectedMember);
                    }}
                >
                    Select
                </Button>
            )
        }
    ];

    useEffect(() => {
        setStartTime(new Date());
    }, []);

    const onHideCallback = () => {
        setApplicationDetails(null);
        onCancel();
        setInitialNormalizedData(null);
        setNoPhoneChecked(false);
    }

    const handleSuccess = () => {
        setIsLoading(false);
        showAlert(messages.success.updateMemberRecord, ALERT_TYPE.SUCCESS);
        onCancel();
    }

    const handleError = (error) => {
        setIsLoading(false);
        showAlert(`${messages.error.prefix} ${error}.`, ALERT_TYPE.ERROR);
    }

    const handleMemberDetailsChange = (update) => {
        setApplicationDetails((details) => ({ ...details, ...update }));
    };

    const handleInputChange = (name, value) => {
        if (name === 'noPhone') {
            const isChecked = Array.isArray(value) && value.length > 0;
            setNoPhoneChecked(isChecked);
            handleMemberDetailsChange({
                noPhone: value,
                phone: isChecked ? null : applicationDetails?.phone,
                phoneType: isChecked ? null : applicationDetails?.phoneType,
            });
        } else {
            handleMemberDetailsChange({ [name]: value });
        }
    };

    const handleSearchDetailsChange = (update) => {
        setSearch((search) => ({ ...search, ...update }));
    }

    const handleSearchInputChange = (name, value) => {
        if (!value) return;
        let updatedSearch = {...search};
        if (name === 'searchByName') {
            setSearchType('name');
            updatedSearch = {
                'searchByApplicationHealthPlanId': null,
                [name]: value,
            };
        } else if (name === 'searchByApplicationHealthPlanId') {
            setSearchType('healthplanmemberid');
            updatedSearch = {
                'searchByName': null,
                [name]: value
            };
        }
        handleSearchDetailsChange(updatedSearch);
    }

    const filterSearchData = (data) => {
        if (!data || !data.length) return [];
        const filtered = data.filter(d => !isSameOrBeforeToday(d.terminationDate));
        return filtered;
    }

    const handleSearch = () => {
        setIsSearchLoading(true);
        setSearchData(null);
        setShowApplicationForm(false);
        setAutoFillMessage('');
        setApplicationDetails(null);
        const searchTerm = searchType === 'healthplanmemberid' ? search?.searchByApplicationHealthPlanId : search?.searchByName;

        const apiCall = searchType === 'healthplanmemberid'
            ? api.getApplicationMemberByHealthPlanId(cohortId, searchTerm)
            : api.getApplicationMemberByName(cohortId, searchTerm);

        apiCall.then(response => {
            const { data } = response;
            const filteredData = filterSearchData(data);
            setIsSearchLoading(false);
            if (filteredData.length === 1) {
                setShowApplicationForm(true);
                setApplicationDetails({
                    ...filteredData[0],
                    applicationHealthPlanId: filteredData[0].healthPlanMemberId,
                    address: filteredData[0].addressLine1,
                    address2: filteredData[0].addressLine2,
                });
                setAutoFillMessage(messages.info.autoFillExactMatch);
            } else if (filteredData.length > 1) {
                const normalizedData = filteredData?.map(d => ({
                    ...d,
                    applicationHealthPlanId: d.healthPlanMemberId,
                    address: d.addressLine1,
                    address2: d.addressLine2,
                }));
                setSearchData(normalizedData);
                setAutoFillMessage(messages.info.autoFillSelectFromMultiple);
            } else if (!filteredData?.length) {
                setShowApplicationForm(true);
                setAutoFillMessage(messages.info.autoFillNoMatch);
            }
        }).catch((error) => {
            setIsSearchLoading(false);
            showAlert(`${messages.error.prefix} ${error}.`, ALERT_TYPE.ERROR);
        });
    }

    const isValidApplicationInfo = () => {
        if (action === FORM_ACTION_TYPE.New) {
            return !isObjectEmpty(applicationDetails);
        }
        if (action === FORM_ACTION_TYPE.Edit) {
            return !checkObjectsEqual(initialNormalizedData, applicationDetails);
        }
        return false;
    };

    const handleSubmit = () => {
        setIsLoading(true);
        const submitData = {
            ...applicationDetails,
            birthday: applicationDetails.birthday ? toDate(applicationDetails.birthday) : null,
            phone: noPhoneChecked ? 'xxxxxxxxxx' : removeHyphens(applicationDetails.phone),
            phoneType: noPhoneChecked ? null : applicationDetails.phoneType,
            primaryLanguage: applicationDetails.primaryLanguage === LANGUAGE_TYPE.Other ? applicationDetails.primaryLanguageOther : applicationDetails.primaryLanguage,
        }

        const encodeCharFields = {
            ...(applicationDetails.participateReason && {
                participateReason: checkAllowedSpecialExists(applicationDetails.participateReason)
            }),
            ...(applicationDetails.deviceWithInternetAccessComment && {
                deviceWithInternetAccessComment: checkAllowedSpecialExists(applicationDetails.deviceWithInternetAccessComment)
            })
        };

        if (action === FORM_ACTION_TYPE.Edit) {
            const updateData = {
                id: data.applicationId,
                ...submitData,
                aGId: data.aGId,
                companyId: data.companyId,
                ...encodeCharFields
            }
            dispatch(updateAdvisoryGroupRecruitmentApplicationData(updateData, handleSuccess, handleError));
        } else if (action === FORM_ACTION_TYPE.New) {
            const submitDate = new Date();
            const addData = {
                ...submitData,
                aGId: data.aGId,
                companyId: data.companyId,
                submittedByExternal: null,
                submittedbyInternal: currentUser?.id,
                submissionType: APPLICATION_SUBMISSION_TYPE.PHARO_USER,
                startTimeDate: startTime.toLocaleDateString() + ' ' + startTime.toLocaleTimeString(),
                submittedTime: submitDate.toLocaleDateString() + ' ' + submitDate.toLocaleTimeString(),
                recordStatus: AG_RECRUITMENT_APPLICATION_STATUS_VALUE.Open,
                evaluationComments: null,
                evaluationUser: currentUser?.id,
                ...encodeCharFields
            }
            dispatch(addAdvisoryGroupRecruitmentApplicationData(addData, handleSuccess, handleError));
        }
    }

    useEffect(() => {
        if (data) {
            const initialData = pickProps(data, ['participateReason', 'applicationHealthPlanId', 'birthday', 'firstName', 'lastName', 'address', 'address2', 'city', 'state', 'postalCode', 'phone', 'phoneType', 'email', 'deviceWithInternetAccess', 'primaryLanguage', 'needTranslator', 'memberStatus', 'deviceWithInternetAccessComment']);

            const languageList = pickList?.[0]?.languageList?.split(',').map((l) => l.trim()) || Object.keys(LANGUAGE_TYPE);
            const isCustomLanguage = initialData.primaryLanguage && !languageList?.includes(initialData.primaryLanguage);
            const hasNoPhone = data?.phone === 'xxxxxxxxxx';

            const normalized = {
                ...initialData,
                birthday: toFormDateTime(initialData.birthday),
                primaryLanguage: isCustomLanguage ? LANGUAGE_TYPE.Other : initialData.primaryLanguage,
                primaryLanguageOther: isCustomLanguage ? initialData.primaryLanguage : '',
                needTranslator: initialData.needTranslator,
                noPhone: hasNoPhone ? ['noPhone'] : [],
                phone: hasNoPhone ? null : initialData.phone,
                phoneType: hasNoPhone ? null : initialData.phoneType,
            };
            setCloneFlag(true);

            setInitialNormalizedData(normalized);
            setApplicationDetails(normalized);
            setNoPhoneChecked(hasNoPhone);
        }
    }, [data, pickList]);

    useEffect(() => {
        if (!applicationDetails?.primaryLanguage) return;

        const isEnglish = applicationDetails.primaryLanguage === LANGUAGE_TYPE.English;

        if (isEnglish && applicationDetails.needTranslator) {
            setApplicationDetails(prev => ({
                ...prev,
                needTranslator: null
            }));
        }
    }, [applicationDetails?.primaryLanguage]);

    useEffect(() => {
        if (applicationDetails?.deviceWithInternetAccess === YES_NO_INVERSE.Yes) {
            setApplicationDetails(prev => ({
                ...prev,
                deviceWithInternetAccessComment: ''
            }));
        }
    }, [applicationDetails?.deviceWithInternetAccess]);

    return (
        <Modal
            show={show}
            fullscreen={false}
            backdrop="static"
            onHide={onHideCallback}
            size={`${action === FORM_ACTION_TYPE.New ? 'lg' : 'md'}`}>
            <Modal.Header closeButton>
                <Modal.Title>AG Member Application</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="px-xl-2 py-xl-2">
                    {
                        action === FORM_ACTION_TYPE.New && (
                        <>
                        <h2 className={styles.title}>Enter a Health Plan ID or Name</h2>
                        <div className={`row gx-3 ${(showApplicationForm || searchData) && 'border-bottom mb-4 pb-3'}`}>
                            <div className="col-8">
                                <SharedForm
                                    cols={6}
                                    array={searchFormArr}
                                    modelObj={search}
                                    actionBarPosition={POSITIONS.NONE}
                                    onInputChanged={handleSearchInputChange}
                                />
                            </div>
                            <div className="col-4 mb-3 d-flex flex-column justify-content-end">
                                <LoadingButton loading={isSearchLoading} disabled={isSearchLoading} onClick={handleSearch}>Search</LoadingButton>
                            </div>
                        </div>
                        </>
                        )
                    }
                    { autoFillMessage && (
                        <h4 className={`${styles.title} mb-3`} role="alert">
                            {autoFillMessage}
                        </h4>
                    )}
                    {
                        searchData && (
                            <div className="mb-4">
                                <DataGrid
                                    data={searchData || []}
                                    columns={columns}
                                    enableFilters={false}
                                />
                            </div>
                        )
                    }
                    <div className="row gx-3">
                        <div className={`${action === FORM_ACTION_TYPE.New ? 'col-8 offset-2' : 'col-12'}`}>
                        {
                            (showApplicationForm || action === FORM_ACTION_TYPE.Edit) && (
                            <SharedForm
                                cols={12}
                                array={arr}
                                modelObj={applicationDetails}
                                loading={isLoading}
                                onInputChanged={handleInputChange}
                                onSubmit={handleSubmit}
                                onCancel={onHideCallback}
                                disabled={!isValidApplicationInfo()}
                                actionBarPosition={action === FORM_ACTION_TYPE.New ? POSITIONS.BOTTOM : POSITIONS.TOP}
                                actionBarAlign={ALIGN.RIGHT}
                                submitButtonText="Save"
                                cloneInitial={cloneFlag}
                            />)
                        }
                        </div>
                    </div>
                </div>
            </Modal.Body>
        </Modal>
    );
}

export default MemberApplicationModal;
